import * as React from 'react'

import { COMPLETE } from '../../../../constants/evidence'
import { MINIMUM_STUDENT_HIGHLIGHT_COUNT } from '../../helpers/containerActionHelpers'

const reviewCorrectSrc = `${window.postbuildEnv.CDN_URL}/images/icons/s/review-correct.svg`

const stepStatus = (done: boolean) => done ? 'Complete' : 'Not complete yet'

const ReadAndHighlightTracker = ({
  scrolledToEndOfPassage,
  studentHighlights,
  handleClickDoneHighlighting,
  handleReadTheDirectionsButtonClick,
  showReadTheDirectionsButton
}) => {
  const minimumMet = studentHighlights.length >= MINIMUM_STUDENT_HIGHLIGHT_COUNT
  const buttonIsEnabled = scrolledToEndOfPassage && minimumMet
  const buttonEnabledCssClass = buttonIsEnabled ? '' : 'disabled'

  if(showReadTheDirectionsButton) {
    return(
      <div className="read-and-highlight-tracker bottom-navigation read-instructions">
        <button aria-label="Next" className="quill-button contained green large focus-on-light" onClick={handleReadTheDirectionsButtonClick} type="button">Got it</button>
      </div>
    )
  }
  return (
    <div className="read-and-highlight-tracker bottom-navigation">
      <div className="read-and-highlight-steps">
        <div className={`read-and-highlight-step ${scrolledToEndOfPassage ? COMPLETE : ''}`}>
          <img alt={stepStatus(scrolledToEndOfPassage)} src={reviewCorrectSrc} />
          <span>Read entire text</span>
        </div>
        <div className={`read-and-highlight-step ${minimumMet ? COMPLETE : ''}`}>
          <img alt={stepStatus(minimumMet)} src={reviewCorrectSrc} />
          <span>Highlight two sentences</span>
        </div>
      </div>
      <button
        className={`quill-button contained green large focus-on-light ${buttonEnabledCssClass}`}
        disabled={!buttonIsEnabled}
        onClick={handleClickDoneHighlighting}
        type="button"
      >
        Done
      </button>
    </div>
  )
}

const BottomNavigation = ({
  scrolledToEndOfPassage,
  studentHighlights,
  handleClickDoneHighlighting,
  handleReadTheDirectionsButtonClick,
  doneHighlighting,
  handleDoneReadingClick,
  hasStartedPromptSteps,
  hasStartedReadPassageStep,
  handleStartPromptStepsClick,
  handleStartReadingPassageClick,
  handleGoodToKnowClick,
  inReflection,
  showGoodToKnow,
  showReadTheDirectionsButton,
  showStepsSummary,
  toggleShowStepsSummary
}) => {

  if (!hasStartedReadPassageStep) {
    return (
      <div className="bottom-navigation">
        {showGoodToKnow
          ? <button className="quill-button contained green large focus-on-light" onClick={handleStartReadingPassageClick} type="button">Start</button>
          : <button className="quill-button contained green large focus-on-light" onClick={handleGoodToKnowClick} type="button">Got it</button>}
      </div>
    )
  }

  if (hasStartedReadPassageStep && !doneHighlighting) {
    return (
      <ReadAndHighlightTracker
        handleClickDoneHighlighting={handleClickDoneHighlighting}
        handleReadTheDirectionsButtonClick={handleReadTheDirectionsButtonClick}
        scrolledToEndOfPassage={scrolledToEndOfPassage}
        showReadTheDirectionsButton={showReadTheDirectionsButton}
        studentHighlights={studentHighlights}
      />
    )
  }

  if (inReflection) {
    return (
      <div className="bottom-navigation">
        <button className="quill-button contained green large focus-on-light" onClick={handleDoneReadingClick} type="button">Next</button>
      </div>
    )
  }

  if (!hasStartedPromptSteps) {
    return (
      <div className="bottom-navigation">
        <button className="quill-button contained green large focus-on-light" onClick={handleStartPromptStepsClick} type="button">Next</button>
      </div>
    )
  }

  if (showStepsSummary) {
    return (
      <div className="bottom-navigation">
        <button className="quill-button contained green large focus-on-light" onClick={toggleShowStepsSummary} type="button">Next</button>
      </div>
    )
  }
}

export default BottomNavigation
